module.exports = __webpack_public_path__ + "static/img/s53.1e10e4bc.png";